<template>
  <div v-if="showPlaceHolder" style="height: 35px; visibility: hidden;">占位</div>
</template>

<script>
import EMKT from '../constant.js'

export default {
  name: 'FooterPlaceholder',
  data () {
    return {
      emkt: EMKT
    }
  },
  props: {
    showPlaceHolder: Boolean
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GcFooterPlaceholder.vue?7088b6f5